import { Component, OnInit } from "@angular/core";
import { NavItem } from "../nav/navItem";
import { MenuService } from "./../../services/menu.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  navItems = [
    new NavItem("about", "About Us"),
    new NavItem("whatwedo", "What we do"),
    new NavItem("referral", "Referral"),
    new NavItem("casestudies", "Case Studies"),
    new NavItem("getinvolved", "Get Involved"),
    new NavItem("debtandmoneyadvice ", "Debt and Money Advice "),
    new NavItem("openingtimes", "Opening Times"),
    new NavItem("findus", "Find Us"),
  ];

  burgerFlipped: boolean;

  constructor(private _menuService: MenuService) {}

  ngOnInit() {
    this._menuService.currentMenuState.subscribe(
      (burgerFlipped) => (this.burgerFlipped = burgerFlipped)
    );
  }

  flipBurger() {
    if (this.burgerFlipped) {
      this._menuService.setMenuState(false);
    } else {
      this._menuService.setMenuState(true);
    }
  }
}



// WEBPACK FOOTER //
// /Users/nicholasmurray/Documents/firebase-websites/CommunityAdviceNMD/src/app/components/header/header.component.ts